import React, { useEffect, useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { useColorStore } from "./stores/ColorStore";
import { BackSide, DoubleSide } from "three";
import { useModelDataStore } from "./stores/ModelDataStore";

export function TBC100(props) {
  const { nodes, materials } = useGLTF("/TBC100.glb");

  const currentBodyColor = useColorStore((state) => state.body)
  const currentCapColor = useColorStore((state) => state.cap)

  let updateUV = useModelDataStore((state) => state.updateUVData)
  useEffect(() => {
    if(props.isBeingEdited)
      updateUV(nodes.TBC100_Etiqueta.geometry.attributes.uv.array)
  }, [props.isBeingEdited])

  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.TBC100_Etiqueta.geometry}>
        <meshStandardMaterial
          map={props.map}
          transparent={false}
          roughness={0.15}
          alphaTest={0.4}
          side={DoubleSide}
        />
      </mesh>
      {/* <mesh geometry={nodes.TBC100_FullWrap.geometry} position={[0, 0.06, 0]}>
        <meshStandardMaterial
            map={props.map}
            transparent={true}
            roughness={0.15}
            alphaTest={0}
        />
      </mesh> */}

      <mesh geometry={nodes.TBC100_Body.geometry}>
        <meshPhysicalMaterial
          // color={props.isBeingEdited ? currentBodyColor : "white"}
          color={"honeyDew"}
          {...props.materialSettings}
        />
        {/* {props.materialSettings != "transparent"
          ? <meshStandardMaterial roughness={0.15} color={props.isBeingEdited ? currentBodyColor : "white"} />
          : <meshPhysicalMaterial roughness={.12} color={props.isBeingEdited ? currentBodyColor : "white"}
            transparent={true}
            transmission={.75}
            thickness={0}
            ior={1.46}
            metalness={.15}
            reflectivity={.65}
            side={DoubleSide}
          />} */}
      </mesh>
      <mesh geometry={nodes.TBC100_Cap.geometry}>
        <meshStandardMaterial roughness={0.22} color={props.isBeingEdited ? currentCapColor : "white"} />
      </mesh>
    </group>
  );
}

useGLTF.preload("/TBC100.glb");

